module.exports = __webpack_public_path__ + "static/img/readtitle.ead2593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/readtitle.png
// module id = laZp
// module chunks = 0